<template>
  <div class="goods-list-combox">
    <el-table :data="pageData.items" border style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="55" />
      <el-table-column align="center" prop="id" label="ID" width="100" />
      <el-table-column prop="title" label="名称" />
      <el-table-column align="center" label="地区" >
        <template slot-scope="scope">
          {{scope.row.provinceText}}/{{scope.row.cityText}}/{{scope.row.countyText}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="statusText" label="状态" width="100"/>
      <el-table-column align="center" prop="ctime" label="创建时间" width="160" />
      <el-table-column header-align="center" label="操作" width="160">
        <template slot-scope="scope">
          <span class="action" v-for="(action,index) in scope.row.actions" :key="'action-' +index" @click="processAction(action.remark, scope.row)">{{action['title']}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="pageData.totalPage">
      <el-pagination background layout="total, prev, pager, next" :current-page="pageData.page" :page-size="pageData.pageSize" :total="pageData.amount" @current-change="handlePageChange" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'MilkSchoolListComponent',
  props: {
    pageData: {}
  },
  data () {
    return {
      ids: [],
      formData: {},
      sortedImgs: [],
      prevImages: [],
      images: [],
      showEditDialog: false
    }
  },
  methods: {
    handleSelectionChange (val) {
      let ids = []
      for (let i in val) {
        ids.push(val[i]['id'])
      }
      this.$emit('onSelectChanged', ids)
    },
    handlePageChange (val) {
      this.$emit('onPageChanged', val)
    },
    processAction (action, data) {
      switch (action) {
        case 'VIEW':
          return this.$emit('view', data)
        case 'EDIT':
          return this.$emit('edit', data)
        case 'ACTIVE':
          return this.$emit('active', data)
        case 'INVALID':
          return this.$emit('invalid', data)
        case 'REMOVE':
          return this.$emit('remove', data)
        default:
          this.$message.error('未知的操作类型')
      }
    }
  }
}
</script>

<style scoped lang="less">
.pagination {
  margin-top: 20px;
  text-align: center;
}

.action {
  color: #3a8ee6;
  padding: 0 5px;

  &:hover {
    cursor: pointer;
  }
}
.image-box{
  .image-item{
    display: inline-block;
  }
}
.goods-thumb {
  width: 130px;
  height: 130px;
  padding: 5px;
  border: solid 1px #ddd;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/school/MilkSchoolListComponent.vue